import { Component, OnInit } from '@angular/core';
import { ModalService } from 'src/app/services/modal.service';

@Component({
  selector: 'app-no-credit-card-added',
  templateUrl: './no-credit-card-added.component.html',
  styleUrls: ['./no-credit-card-added.component.scss'],
})
export class NoCreditCardAddedComponent implements OnInit {
  constructor(
    public readonly modalService: ModalService,
  ) {}

  ngOnInit() {
    return;
  }
}
